<template>
  <v-card
      class="pt-3 px-4 ma-0 oder-box-products"
      :style="{
              background: '#fffbf8',
              border: '1px solid #cccccccc',
              overflow: 'auto',
            }"
      outlined
      tile
  >
    <div class="d-flex  mt-3">
        <div class="pr-3 pl-3" style="width: 200px;color: #ac0606; font-weight: 600; font-size: 14px;margin-top: 2px;">Biên nhận thanh toán</div>
        <div class="d-flex pl-6">
          <div class="d-flex pl-6">
            <v-radio-group @change="handleChangeOrderProduct()" v-model="product.orderTypeProduct" row style="margin: 0 !important; padding: 0 !important;">
              <v-radio label="Tính theo giá cọc" :value="1" color="green" class="pr-3" ></v-radio>
              <v-radio label="Tính theo giá full" :value="2" color="green"></v-radio>
            </v-radio-group>
          </div>
        </div>
    </div>
    <v-row>
      <v-col cols="12" class="py-0 pt-2">
        <v-simple-table
            class="table-layout table-order-custom-tutor"
            :style="{  background: '#fffbf8'}">
          <thead>
          <tr>
            <th class="col-program text-left" style="font-size: 12px !important">
              SẢN PHẨM KHÓA HỌC
            </th>
            <th class="col-teacher text-left" style="font-size: 12px !important">
              ĐÃ HỌC
            </th>
            <th class="col-package text-left" style="font-size: 12px !important">
             CÒN LẠI
            </th>
            <th class="col-package text-left" style="font-size: 12px !important;">
              MUỐN CHUYỂN
            </th>
            <th class="col-package text-left" style="font-size: 12px !important">
              ĐƠN GIÁ
            </th>
            <th class="col-package text-left" style="font-size: 12px !important">
              ₫ THÀNH TIỀN
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="input-disabled-block">
                {{ product.name }}
              </div>
            </td>
            <td>
              <div class="input-disabled-block">
                {{ product.numberLessonPassed }} tháng
              </div>
            </td>
            <td>
              <div class="input-disabled-block">
                {{ product.numberLessonRemaining }} tháng
              </div>
            </td>
            <td style="max-width: 120px;width: 120px;">
              <div class="d-flex align-center" style="column-gap: 8px;">
                <validation-provider
                    v-slot="{ errors }"
                    :name="`Số tháng chuyển`"
                    :rules="{ required: true}"
                    tag="div"
                    style="width: 70px"
                >
                  <v-text-field
                      :error-messages="errors"
                      label=""
                      placeholder="Nhập số"
                      dense
                      :min="1"
                      :max="product.numberLessonRemaining"
                      type="number"
                      @input="validateAmount()"
                      :disabled="!product.isEditTransfer"
                      v-model="product.numberLessonTransfer"
                  ></v-text-field>
                </validation-provider>
                <span> tháng</span>
                <v-tooltip v-if="!product.isEditTransfer" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEditTransfer(product)" color="#5D62D1" icon small v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                  <span>Chỉnh sửa số tháng</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEditTransfer(product)" icon small v-on="on"><v-icon>mdi-close-circle</v-icon></v-btn>
                  </template>
                  <span>Hủy bỏ</span>
                </v-tooltip>
              </div>
            </td>
            <td>
              <div class="input-disabled-block">
                {{ product.orderTypeProduct ===  2 ? (product.price ? formatCurrencyNoD_C(product.price) : 0)
                  : (product.priceDeposit ? formatCurrencyNoD_C(product.priceDeposit) : 0) }}
              </div>
            </td>
            <td>
              <div class="d-flex" style="column-gap: 12px;">
                <validation-provider
                    v-slot="{ errors }"
                    :name="`Thành tiền`"
                    :rules="{ required: true }"
                >
                  <v-text-field
                      v-if="product.orderTypeProduct === 2 "
                      :error-messages="errors"
                      label=""
                      placeholder="Nhập thành tiền"
                      dense
                      :min="1"
                      type="number"
                      @input="handleInputChange"
                      :disabled="!product.isEdit"
                      v-model="product.intoMoney"
                  ></v-text-field>
                  <v-text-field
                      v-else
                      :error-messages="errors"
                      label=""
                      placeholder="Nhập thành tiền"
                      dense
                      :min="1"
                      type="number"
                      @input="handleInputChange"
                      :disabled="!product.isEdit"
                      v-model="product.intoMoneyDeposit"
                  ></v-text-field>
                </validation-provider>
                <v-tooltip v-if="!product.isEdit" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEdit(product)" color="#5D62D1" icon small v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                  <span>Chỉnh sửa thành tiền</span>
                </v-tooltip>
                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="" @click="handleEdit(product)" icon small v-on="on"><v-icon>mdi-close-circle</v-icon></v-btn>
                  </template>
                  <span>Hủy bỏ</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>


import {formatCurrencyNoD_C} from "../HelperFunc";
import OrderRepository from "../../../../repositories/OrderRepository";

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    orderId: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      originalProduct: {},
    };
  },
  created() {
    this.originalProduct = _.cloneDeep(this.product)
  },
  methods: {
    formatCurrencyNoD_C,
    handleInputChange() {
      if (this.product.orderTypeProduct === 2) {
        this.product.intoMoney = this.product.intoMoney ? this.product.intoMoney.replace(/[^0-9.]/g,'') : null;
      } else {
        this.product.intoMoneyDeposit = this.product.intoMoneyDeposit ? this.product.intoMoneyDeposit.replace(/[^0-9.]/g,'') : null;
      }
      this.$emit('productUpdated', {
        product: this.product,
        index: this.indexProd
      });
    },
    handleChangeOrderProduct() {
      this.validateAmount();
      setTimeout(() => {
        if(this.product.numberLessonTransfer === null || this.product.numberLessonTransfer === '') {
          this.product.numberLessonTransfer = 0;
        }
      }, 500)
    },
    validateAmount: _.debounce(async function () {
      this.product.numberLessonTransfer = this.product.numberLessonTransfer ? this.product.numberLessonTransfer.replace(/[^0-9.]/g,'') : null
      if (this.product.numberLessonTransfer !== null && parseInt(this.product.numberLessonTransfer) > this.product.numberLessonRemaining) {
        this.product.numberLessonTransfer = _.cloneDeep(this.product.numberLessonRemaining);
        return
      }
      if(this.product.numberLessonTransfer !== null) {
        const params = {
          orderProductId: this.product.orderProductId,
          numberLessonTransfer: this.product.numberLessonTransfer,
          isCalcUnusedReceiptAmount: this.product.isCalcUnusedReceiptAmount,
          orderId: this.orderId,
        }
        const response = await OrderRepository.getIntoMoneyPaymentReceiptApi(params)
        if (response.success) {
          if (this.product.orderTypeProduct === 1) {
            this.product.intoMoneyDeposit = response.data && response.data.intoMoneyDeposit ? response.data.intoMoneyDeposit : 0;
          } else if (this.product.orderTypeProduct === 2) {
            this.product.intoMoney = response.data && response.data.intoMoney ? response.data.intoMoney : 0;
          }
          this.$emit('productUpdated', {
            product: this.product,
            index: this.indexProd
          });
        }
      }else {
        // this.product.numberLessonTransfer = 0
        // if (this.product.orderTypeProduct === 1) {
        //   this.product.intoMoneyDeposit = 0;
        // } else if (this.product.orderTypeProduct === 2) {
        //   this.product.intoMoney = 0;
        // }
      }
    }, 500),
    handleEditTransfer(product) {
      if (!product.isEditTransfer) {
        product.isEditTransfer = true
      }else {
        product.isEditTransfer = false
        product.numberLessonTransfer = this.originalProduct.numberLessonTransfer;
        product.intoMoney = this.originalProduct.intoMoney;
        product.intoMoneyDeposit = this.originalProduct.intoMoneyDeposit;
        this.$emit('productUpdated', {
          product: this.product,
          index: this.indexProd
        });
      }
    },
    handleEdit(product) {
      if (!product.isEdit) {
        product.isEdit = true
        this.originalProduct = _.cloneDeep(this.product);
      } else {
        product.isEdit = false
        this.product.intoMoney = this.originalProduct.intoMoney;
        this.product.intoMoneyDeposit = this.originalProduct.intoMoneyDeposit;
        this.$emit('productUpdated', {
          product: this.product,
          index: this.indexProd
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep input[type=number]::-webkit-inner-spin-button,
::v-deep input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Cho Firefox */
::v-deep input[type=number] {
  -moz-appearance: textfield;
}

::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}

.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
.v-text-field--outlined.v-input--dense.v-text-field--outlined
> .v-input__control
> .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom {
  .col-program {
    width: 12%;
  }
  .col-package {
    width: 12%;
  }
  .col-product {
    width: 12%;
  }
  .col-price {
    width: 12%;
  }
  .col-discount {
    width: 12%;
  }
  .col-total {
    width: 12%;
  }
  .col-child {
    width: 12%;
  }
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}

.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}

.cursor-pointer {
  cursor: pointer;
}
.input-disabled-block {
  border-bottom: 1px solid #d2d2d2;
  text-align: left !important;
  padding-bottom: 3px;
  color: #495057;
  margin-top: -12px !important;
}
</style>